import { Progress } from "@chakra-ui/react"
import { useCountUp } from "@hooks/useCountUp"
import { useEffect } from "react"

const DetailedRatingProgressBar = ({
  rating,
  count,
  isCounting,
}: {
  rating: number
  count: number
  isCounting: boolean
}) => {
  const { value, reset } = useCountUp({
    isCounting: isCounting,
    end: rating,
    decimalPlaces: 2,
    duration: 0.5,
  })

  useEffect(() => {
    if (!isCounting) {
      reset()
    }
  }, [isCounting, reset])

  return (
    <Progress
      hasStripe
      value={value ? (Number(value) / count) * 100 : 0}
      colorScheme={"yellow"}
      size={"md"}
      w={"full"}
    />
  )
}

export default DetailedRatingProgressBar
